/**
 * @file Checkmark icon for completed lab steps and selection state.
 * @module @labcraft/ui/icons/check
 *
 * Inline SVG inheriting `currentColor`. Consumers control size via
 * `width`/`height` props or CSS, color via `color` on a parent.
 */

import type { JSX, SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

/**
 * Checkmark icon.
 *
 * @param props - Pass-through props for the underlying `<svg>`.
 * @returns The rendered icon.
 */
export function CheckIcon(props: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 14 14"
      width={14}
      height={14}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}>
      <polyline points="3,7 6,10 11,4" />
    </svg>
  )
}
